export default __webpack_public_path__ + "static/media/64.9b8798b8.jpg";